__turbopack_context__.v({
  "toolTipActive": "ToolTipsOverlay-module-scss-module__hKMORa__toolTipActive",
  "toolTipBody": "ToolTipsOverlay-module-scss-module__hKMORa__toolTipBody",
  "toolTipWrapper": "ToolTipsOverlay-module-scss-module__hKMORa__toolTipWrapper",
});
